import { defaultMemoize } from 'reselect';

function isShallowEqual(v1, v2) {
  return Object.keys(v1).length === Object.keys(v2).length &&
    Object.keys(v1).every(k => v1[k] === v2[k]);
}

function isPojo(value) {
  return value && (
    Object.getPrototypeOf(value) === Object.prototype ||
    Object.getPrototypeOf(value) === Array.prototype
  );
}

function refPreservingReplace(oldValue, newValue) {
  if (oldValue === newValue) {
    return oldValue;
  }
  if (!(isPojo(oldValue) && isPojo(newValue))) {
    return newValue;
  }
  if (Array.isArray(newValue)) {
    const merged = newValue.map((val, i) => refPreservingReplace(oldValue[i], val));
    return isShallowEqual(merged, oldValue) ? oldValue : merged;
  }
  const merged = {};
  Object.setPrototypeOf(merged, Object.getPrototypeOf(newValue));
  for (const k in newValue) {
    if (newValue.hasOwnProperty(k)) {
      merged[k] = refPreservingReplace(oldValue[k], newValue[k]);
    }
  }
  return isShallowEqual(merged, oldValue) ? oldValue : merged;
}

export function refPreserving(f) {
  let lastResult;
  return (...args) => {
    const result = f(...args);
    if (!lastResult) {
      lastResult = result;
      return result;
    }
    lastResult = refPreservingReplace(lastResult, result);
    return lastResult;
  };
}

export function setRefPreserving(f) {
  const processResult = defaultMemoize(set => set,
    (s1, s2) => {
      if (s1.size !== s2.size) {
        return false;
      }
      for (const s of s1) {
        if (!s2.has(s)) {
          return false;
        }
      }
      return true;
    });
  return (...args) => processResult(f(...args));
}
